export const UserDetails = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const isSuccess = crypto.getRandomValues(new Uint8Array(1))[0] > 127
      if (isSuccess) {
        resolve({message: 'Data fetched successfully!'})
      } else {
        reject('Error: Something went wrong.')
      }
    }, 2000)
  })
}
